import { Flex, Spinner, Text, VStack } from "@chakra-ui/react";
import { ReactElement } from "react";

interface LoadingSpinnerProps {
  text?: string;
}

export default function LoadingSpinner(
  props: LoadingSpinnerProps
): ReactElement {
  const { text = "Loading" } = props;

  return (
    <Flex w="100%" h="70vh" justify="center" align="center">
      <VStack spacing="2">
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
        <Text>{text} &hellip;</Text>
      </VStack>
    </Flex>
  );
}
